import { Button, TextInput, Theme } from '@spoiler-alert/ui-library';
import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import EmailPill from './email-pill';

const useStyles = createUseStyles(
  {
    newEmail: {
      display: 'flex',
      gap: 15,
      alignItems: 'center',
    },
    emailPills: {
      display: 'flex',
      gap: 10,
      margin: [10, 0],
      flexWrap: 'wrap',
      '&>*': {
        padding: [5, 8],
        fontSize: 10,
      },
    },
    emailBox: {
      border: `2px solid ${Theme.grey10}`,
      padding: 15,
    },
    emailInput: {},
  },
  { name: 'EmailList' },
);

interface EmailListArgs {
  label: React.ReactNode;
  list: string[];
  onChange: (newList: string[]) => void;
}

const EmailList: React.FC<EmailListArgs> = ({ label, list, onChange }) => {
  const classes = useStyles();
  const [editingEmail, setEditingEmail] = useState<string>('');

  const removeEmail = (email: string) => {
    onChange(list.filter((e) => e !== email));
  };

  const addEmail = () => {
    onChange([...new Set([...list, editingEmail.toLowerCase()])]);
    setEditingEmail('');
  };

  const handleSubmit = (event: React.KeyboardEvent<HTMLFormElement>) => {
    event.stopPropagation();
    event.preventDefault();
    addEmail();
  };

  const editEmail = (email: string) => {
    removeEmail(email);
    setEditingEmail(email);
  };

  return (
    <form className={classes.emailBox} onSubmit={handleSubmit}>
      <label>{label}</label>
      <div className={classes.emailPills}>
        {list.map((be) => (
          <EmailPill key={`.pill-${be}`} email={be} onRemove={removeEmail} onEdit={editEmail} />
        ))}
      </div>
      <div className={classes.newEmail}>
        <TextInput
          inputClassName={classes.emailInput}
          onChange={(value: string) => setEditingEmail(value)}
          type="email"
          labelText="Add New Contact"
          value={editingEmail}
        />
        <Button type="button" onClick={addEmail}>
          +
        </Button>
      </div>
    </form>
  );
};

export default EmailList;
